import { actions } from './actions';
import { mutations } from './mutations';
import { User } from 'packages/users/User';
var state = {
    user: new User(),
    loading: false,
    uploadingAvatar: false,
};
export var profile = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
